import type { NavigationItem } from '../../tokens/navigationPaths';
import type { LayoutSpec } from '../../types/LayoutConfig';

export function getLayoutSpecForNavItem({
  item,
  sectionLayoutConfigs,
}: {
  item: NavigationItem | null | undefined;
  sectionLayoutConfigs: readonly LayoutSpec[] | undefined;
  staleLayoutOptions?: Record<string, LayoutSpec> | undefined;
}): LayoutSpec | undefined {
  if (item?.id == null || sectionLayoutConfigs == null) {
    return undefined;
  }
  return sectionLayoutConfigs.find(layout => layout.id === item.id);
}
